module.exports = "<div class=\"col-xs-12 content-right\">\r\n  <a *ngIf=\"!isAuthenticated\" (click)=\"logIn()\" class=\"page-link\">Log In</a>\r\n  <a *ngIf=\"isAuthenticated\" (click)=\"logOut()\" class=\"page-link\">Log Out</a>\r\n  <div *ngIf=\"isAuthenticated\">Welcome {{user.firstName}} {{user.lastName}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/login/login.component.html
// module id = ./src/app/layout/login/login.component.html
// module chunks = main